var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlameLevel4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.02 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0ba1e2;}.cls-2{fill:#dbdbdb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flame level") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.25,23.88C34.25,4,18.33,0,18.33,0c8,8,4,19.9,0,19.9S14.35,8,14.35,8c-8,11.94-.86,17.78-4.64,20.57-2.8,2.06-5.16-2.22-5.16-2.22-3.21,11.36,4.34,23,14.68,25.11a19,19,0,0,0,9.19-.4C37.57,48.62,41.48,40.48,40,31.4c-2-12.33,2.21-15.48,2.21-15.48C34.25,15.92,34.25,23.88,34.25,23.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.19,64H1.83a1.83,1.83,0,1,1,0-3.66H44.19a1.83,1.83,0,1,1,0,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.81,62.17c0-1,1.43-1.83,2.44-1.83H1.83a1.83,1.83,0,1,0,0,3.66H22.25C21.24,64,19.81,63.18,19.81,62.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,60.34H17.37c1,0-.61.82-.61,1.83S18.38,64,17.37,64H25a1.83,1.83,0,1,0,0-3.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameLevel4);
export default __webpack_public_path__ + "static/media/Flame_level_4.334dd530c84bef4bdd146041088d74f1.svg";
export { ForwardRef as ReactComponent };